const renderToCoverValue = quoteData => {
  if (!quoteData || !quoteData.prospectDetails || !quoteData.prospectDetails.dependents) {
    return 'You';
  }

  const dependents = quoteData.prospectDetails.dependents;
  const hasSpouse = typeof dependents.spouse === 'object' && dependents.spouse !== null;
  const numChildren = Array.isArray(dependents.children) ? dependents.children.length : 0;

  if (numChildren > 0) {
    const childString = `${numChildren} child${numChildren > 1 ? 'ren' : ''}`;
    if (hasSpouse) {
      return `You, a partner and ${childString}`;
    } else {
      return `You and ${childString}`;
    }
  }

  if (hasSpouse) {
    return 'You and a partner';
  }

  return 'You';
};

export default renderToCoverValue;
